module.exports = __webpack_public_path__ + "static/media/thank_you_icon.e81b7340.svg";